var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.tag,
    _vm._b(
      { tag: "component", attrs: { tag: "li" } },
      "component",
      _vm.$attrs,
      false
    ),
    [
      _c(
        "router-link",
        _vm._b({}, "router-link", _vm.$attrs, false),
        [
          _vm._t("default", [
            _vm._v("\n      " + _vm._s(_vm.link.name) + "\n    ")
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }